import {postData, sendRequest} from "./request";
import {store} from "src/store";
import axios from "axios";
import {array_combine, array_fill, count, krsort} from "locutus/php/array";
import {is_scalar} from "./other";
import {set} from "./dotutils";

const configRequests = {};

const configs = {};

export const getFieldConfig = async (config, field) => {
    let f = field.split(".");
    const currentField = f.shift();
    const nextField = f.join(".");
    if (!config.fielddefs[currentField]) {
        if (config.target) {
            config = await getComponentConfig(config.target);
        }
        // TODO adapter
        /* else if (config.objects) {
            for (let object in config.objects) {
                config = await getComponentConfig(object);
                if (config.fielddefs[field]) {
                    return config;
                } else {
                    return await this.loadConfig(config, field);
                }
            }
        }*/
    }
    if (config.fielddefs[currentField]) {
        if (!f.length) {
            return config;
        } else {
            if (config.fielddefs[currentField].objects || config.fielddefs[currentField].object) {
                config = await getComponentConfig(config.fielddefs[currentField].objects || config.fielddefs[currentField].object);
                return getFieldConfig(config, nextField);
            }
            return null;
        }
    } else {
        return null;
    }
}

export const getComponentConfig = (componentName) => {
    let abort = false;
    let request = null;
    const r = new Promise((resolve, reject) => {
        //const editors = store.getState().editors;
        let config = configs[componentName];// || (editors[componentName] || {}).componentConfig;
        if (!config) {
            request = configRequests[componentName];
            if (!request) {
                request = configRequests[componentName] = postData({
                    action: componentName + ".getComponentConfig"
                }, {}, {showError: false});
            }
            request.then((componentConfig) => {
                if (abort) {
                    reject({});
                }
                delete configRequests[componentName];
                if (componentConfig.componentname) {
                    configs[componentName] = componentConfig;
                    !abort && resolve(JSON.parse(JSON.stringify(componentConfig)));
                } else {
                    !abort && reject(componentConfig);
                }
            });
            request.catch((e) => {
                if (e instanceof axios.Cancel || abort) {
                    reject({});
                }
                delete configRequests[componentName];
                !abort && reject(e);
            });
        } else {
            !abort && resolve(JSON.parse(JSON.stringify(config)));
        }
    });
    r.abort = () => {
        abort = true;
        request && request.abort();
    };
    return r;
};

export const saveComponent = (componentName, data, action = null) => {
    let aborted = false;
    const p = new Promise(async (resolve, reject) => {
        try {
            const componentConfig = await getComponentConfig(componentName);
            action = action || (!data[componentConfig.idfield] ? "create" : "update");

            let requestData = {
                action: componentName + "." + action,
                data
            };
            resolve(await postData(requestData));
        } catch (e) {
            reject(e);
        }
    });
    p.abort = () => {
        aborted = true;
    };
    return p;
};

export const deleteComponent = (componentName, data) => {
    let requestData = {
        action: componentName + ".delete",
        ...data
    };
    return postData(requestData);
};

export const loadComponentById = (componentName, id, view = "default", params = {}) => {
    let aborted = false;
    let request = null;
    const p = new Promise((resolve, reject) => {
        request = getComponentConfig(componentName);
        request.then((componentConfig) => {
            if (aborted) {
                reject({});
            }
            request = sendRequest({
                option: componentName,
                view,
                [componentConfig.idfield]: id,
                ...params
            });
            request.then((response) => {
                if (aborted) {
                    reject({});
                }
                resolve(response);
            });
            request.catch((e) => {
                reject(e);
            });
        });
        request.catch((e) => {
            reject(e);
        });
    });
    p.abort = () => {
        aborted = true;
        request && request.abort();
    };
    return p;
};

export const loadComponent = (componentName, params, view = "default") => {
    return sendRequest({
        option: componentName,
        view,
        ...params
    });
};

export const createComponent = (componentName, params, view = "default") => {
    return postData({
        action: componentName + ".create",
        view,
        ...params
    });
};

export const fieldFilter = (field, value, operator = null) => {
    const filter = {field, value};
    if (operator) {
        filter.operator = operator;
    }
    return filter;
}

export const formatView = (...views) => {
    let result = null;
    views.map((view) => {
        if (Array.isArray(view)) {
            let aView = {};
            view.map((key) => {
                set(aView, key, null);
            });
            view = aView;
        } else {
            Object.entries(view).map((entry) => {
                let name = entry[0];
                let subView = entry[1];
                if (subView === "") {
                    view[name] = null;
                } else if (Array.isArray(subView) || (subView && typeof subView === "object")) {
                    view[name] = formatView(subView);
                }
            });
        }
        let aView = {};
        krsort(view);
        Object.entries(view).map((entry) => {
            let key = entry[0];
            let value = entry[1];
            set(aView, key, value);
        });
        view = aView;
        if (result == null) {
            result = view;
        } else {
            Object.entries(view).map((entry) => {
                let name = entry[0];
                let subView = entry[1];
                if (result[name] && subView && is_scalar(result[name]) && is_scalar(subView)) {
                    throw {message: "'" + result[name] + " and '" + subView + "' cannot merge at the same time!"};
                }
                if (Array.isArray(result[name] || null) && Array.isArray(subView)) {
                    result[name] = formatView([...result[name], ...subView]);
                } else {
                    result[name] = subView;
                }
            });
        }
    });
    return result || {};
}